import React, { useContext, useEffect, useState } from "react";

import {
  Button,
  Container,
  Grid,
  Modal,
  Pagination,
  Paper,
  SegmentedControl,
  Text,
} from "@mantine/core";
import dayjs from "dayjs";

import { AppName, BrandImages, Colors } from "../../Lib/Data";

import { useDisclosure } from "@mantine/hooks";
import { Link } from "react-router-dom";
import DisplayAlert from "../../Components/DisplayAlert";
import MegaLoader from "../../Components/MegaLoader";
import { Endpoints } from "../../Lib/Endpoints";
import { PaginatedResponse } from "../../Lib/Responses";
import { MySubscriptionProps, PaginationProps } from "../../Lib/Types";
import { usePerformRequest } from "../../Lib/usePerformRequest";
import { AppContext } from "../Wrapper";

import "./styles.scss";
import { generateRandomString, getPaginationTotal } from "../../Lib/Methods";

const MySubscriptions: React.FC = () => {
  const context = useContext(AppContext);
  const theme = context?.theme ?? "light";

  document.title = `My Subscriptions | ${AppName}`;

  const [activeTab, setActiveTab] = useState<"active" | "inactive">("active");

  const [pagination, setPagination] = useState<PaginationProps>({
    page: 1,
    limit: 20,
  });
  const {
    data: subscriptions,
    isLoading: isLoadingSubscriptions,
    reloadData: reloadSubscriptions,
  } = usePerformRequest<PaginatedResponse<MySubscriptionProps[]>>({
    method: "POST",
    body: {
      status: activeTab,
    },
    route: Endpoints.GetSubscriptions(pagination),
  });
  const [selectedSubscription, setSelectedSubscription] =
    useState<MySubscriptionProps>();
  const [
    isSubscriptionDetailsModalOpened,
    {
      open: OpenSubscriptionDetailsModal,
      close: CloseSubscriptionDetailsModal,
    },
  ] = useDisclosure(false);

  const onCloseModal = () => {
    CloseSubscriptionDetailsModal();
    setSelectedSubscription(undefined);
  };

  useEffect(() => {
    reloadSubscriptions();
  }, [activeTab]);
  return (
    <Container size="lg">
      <div className="my-subscriptions-container width-100">
        <div className="flex-col width-100 align-center justify-center">
          <Text
            className="header"
            mb={10}
            c={theme === "dark" ? Colors.White : Colors.GreenSecondary}
          >
            My Subscriptions
          </Text>
          <SegmentedControl
            value={activeTab}
            //@ts-ignore
            onChange={setActiveTab}
            classNames={{
              root: "tabs-root",
              control: "tabs-control",
              indicator: "tabs-indicator",
              label: "tabs-label",
              innerLabel: "tabs-inner-label",
            }}
            data={[
              { label: "Active", value: "active" },
              { label: "Inactive", value: "inactive" },
            ]}
          />
        </div>
        <br />
        <>
          {isLoadingSubscriptions ? (
            <MegaLoader />
          ) : (
            <>
              {subscriptions &&
              subscriptions.data &&
              subscriptions.data.length ? (
                <>
                  <Grid gutter={20}>
                    {subscriptions.data.map((subscription) => {
                      return (
                        <Grid.Col
                          span={{ base: 12, sm: 6, lg: 4 }}
                          key={generateRandomString(12)}
                        >
                          <Paper
                            withBorder
                            className={`item flex-col justify-between item-${theme}`}
                          >
                            <div className="flex-row align-center justify-between">
                              <Text
                                c={
                                  theme === "dark"
                                    ? Colors.White
                                    : Colors.GreenSecondary
                                }
                                fz={18}
                                fw={600}
                              >
                                {subscription.service}
                              </Text>
                              <img
                                src={BrandImages.retrieveImage(
                                  subscription.service,
                                  theme
                                )}
                                alt=""
                                className="image"
                              />
                            </div>
                            <div className="flex-col width-100">
                              <Text
                                fz={13}
                                c={
                                  theme === "dark"
                                    ? "var(--mantine-color-gray-5)"
                                    : "dimmed"
                                }
                              >
                                Valid until:
                              </Text>
                              <Text
                                c={
                                  dayjs().isAfter(subscription.expiresAt)
                                    ? Colors.RedPrimary
                                    : Colors.GreenPrimary
                                }
                                fz={13}
                              >
                                {dayjs(subscription.expiresAt).format(
                                  "ddd, MMMM DD YYYY"
                                )}
                              </Text>
                            </div>
                            <Link
                              style={{ width: "100%" }}
                              to={`/d/subscriptions/${subscription.id}`}
                            >
                              <Button fullWidth variant="outline">
                                View Details
                              </Button>
                            </Link>
                          </Paper>
                        </Grid.Col>
                      );
                    })}
                  </Grid>
                  <div className="flex-row align-center justify-center width-100">
                    <Pagination
                      value={pagination.page}
                      onChange={(value) => {
                        setPagination({ ...pagination, page: value });
                      }}
                      my={40}
                      disabled={isLoadingSubscriptions}
                      total={getPaginationTotal(
                        subscriptions?.totalRecords,
                        pagination.limit
                      )}
                    />
                  </div>
                </>
              ) : (
                <DisplayAlert
                  title="No Subscriptions Found"
                  children={
                    <div className="flex-col">
                      <Text>
                        {context?.profile && context.profile.id
                          ? "You have no existing subscriptions!"
                          : "You must log in first!"}
                      </Text>
                      <Link
                        to={
                          context?.profile && context.profile.id
                            ? "/d/services"
                            : "/login"
                        }
                      >
                        <Button mt={10} color={Colors.GreenPrimary}>
                          {context?.profile && context.profile.id
                            ? "Purchase Service"
                            : "Login"}
                        </Button>
                      </Link>
                    </div>
                  }
                />
              )}
            </>
          )}
        </>

        <Modal
          zIndex={99999999}
          opened={isSubscriptionDetailsModalOpened}
          onClose={onCloseModal}
          withCloseButton={false}
          centered
          size="lg"
        >
          {selectedSubscription && (
            // <SingleSubscription
            //   onCloseModal={onCloseModal}
            //   subscription={selectedSubscription}
            // />
            <></>
          )}
        </Modal>
      </div>
    </Container>
  );
};

export default MySubscriptions;
